import { z } from 'zod';

export const PositionProductConfigurationSchema = z.strictObject({
    positionProductId: z.string().uuid(),
    showZeroPurchasePrice: z.boolean(),
    showZeroSalesPrice: z.boolean(),
});

export type PositionProductConfiguration = z.infer<typeof PositionProductConfigurationSchema>;
